/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-lines-per-function */
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { ConfigService } from '../services/config/config.service';
import {
  claimTypes,
  FROM_BOOKING_QUERY_PARAM,
  FROM_PRIVATE_COMPLETE_DETAILS,
  userTypes,
  whiteLabelNames,
} from '../appsettings';
import { RegistrationService } from '../components/indigo-yellow-ui/registration/registration.service';
import { RegistrationSidebarService } from '../components/indigo-yellow-ui/components/registration-sidebar/registration-sidebar.service';

const saveFromPrivateCompleteDetails = () => {
  const isFromPrivateCompleteDetails = true;
  localStorage.setItem(FROM_PRIVATE_COMPLETE_DETAILS, JSON.stringify(isFromPrivateCompleteDetails));
};

const saveFromBookingToLocalStorage = () => {
  const isFromBooking = true;
  localStorage.setItem(FROM_BOOKING_QUERY_PARAM, JSON.stringify(isFromBooking));
};

export const itRegistrationGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const auth = inject(AuthService);
  const config = inject(ConfigService);
  const registrationService = inject(RegistrationService);
  const registrationSidebar = inject(RegistrationSidebarService);

  const isIt = (config._envConfig.WhiteLabelName as whiteLabelNames) === whiteLabelNames.ITALY;

  // disregard this guard for other tenants except for IT/Global
  const skipTenant = ![whiteLabelNames.ITALY, whiteLabelNames.GLOBAL].includes(
    config._envConfig.WhiteLabelName as whiteLabelNames,
  );
  if (skipTenant) {
    return true;
  }

  if (state.url.includes('/register/private-complete-details')) {
    return true;
  }

  const claims = await firstValueFrom(auth.userInfo$);
  const getClaim = (type: string) => claims[type] ?? '';
  const rawEmail = getClaim('email');
  const rawDob = getClaim('date_of_birth');
  const fiscalCode = getClaim('fiscal_code').toUpperCase();
  const isProfileComplete = getClaim('it_complete_profile').toLowerCase() === 'true';
  const userType = getClaim(claimTypes.USER_TYPE);
  const allUserTypes: string[] = typeof userType === 'string' ? [userType] : userType;
  const isSaUser = allUserTypes.includes(userTypes.SYNLAB_ACCESS_USER);

  if (!isProfileComplete && isIt && isSaUser) {
    registrationService.registeredUserData.set({
      userId: getClaim('userId'),
      synlabId: getClaim('synlab_id'),
    });
    registrationService.personalInfo.set({
      confirmPassword: '',
      date_of_birth: rawDob,
      email: rawEmail,
      noFiscalCode: !fiscalCode,
      password: '',
      [claimTypes.FISCAL_CODE]: fiscalCode,
    } as any);

    registrationSidebar.shouldCompleteProfile.set(true);
    router.navigateByUrl('/register/complete-details');

    saveFromPrivateCompleteDetails();
    saveFromBookingToLocalStorage();

    return false;
  }
  return true;
};
